enum NegotiationState {
  BUYER_OFFER = 'buyer_offer',
  BUYER_COUNTER = 'buyer_counter',
  BUYER_FIRM = 'buyer_firm',
  SELLER_OFFER = 'seller_offer',
  SELLER_COUNTER = 'seller_counter',
  FINAL_ASKING_PRICE = 'final_asking_price',
  DECLINED = 'declined',
  NO_NEGOTIATION = 'no_negotiation',
  ACCEPTED = 'accepted'
}

export default NegotiationState;

export const LIMITS = {
  COMMENTS_SIZE: 4096
};
